
<template lang="">
<FullScreenLayout>
    <template #page-content="props">
     <v-container class="fill-height justify-center page" fluid style="background-color: #4d606a;">
          <v-row 
                style="z-index:100;">
            <v-col
                class="d-none d-sm-flex"
                sm="6"
                lg="5"
                offset-lg="1"
                >
                    <iframe width="100%" height="435px" src="https://www.youtube.com/embed/gkoMzk_hju8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </v-col>
            <v-col 
                xs="12"
                sm="6"
                lg="4" 
                offset-lg="1"
                >
                    
                        <FrmLoginOwner></FrmLoginOwner>
         

            </v-col>
        </v-row>
        <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="90"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="false"
        clickMode="push"
      >
      </vue-particles>
      </v-container>
      </template>
</FullScreenLayout>
</template>
<style lang="scss">
#particles-js {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
}
.mainPage[isMobile] #frm-login{
       position: fixed;
    top: 0px;
    left: 0px;
    border-radius: 0 !important;
    right: 0;
    bottom: 0;
 }
</style>

 <script>
import Vue from "vue";
import VueParticles from "vue-particles";
import FrmLoginOwner from "../components/FrmLogin/FrmLoginOwner";
import FullScreenLayout from "../layout/FullScreenLayout.vue";
export default {
  components: {
    FrmLoginOwner,
    FullScreenLayout
  },
};
</script>